// extracted by mini-css-extract-plugin
module.exports = {"form":"MealForm_form__2qiGn","input":"MealForm_input__2iYzt"};